var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('div',[(_vm.metadata['showDate'])?_c('span',{staticClass:"mr-2"},[_vm._v(" "+_vm._s(_vm._f("dateFormat")(new Date(this.value),"DD/MM/YYYY"))+" ")]):_vm._e(),(_vm.metadata['showTime'])?_c('span',[_vm._v(" "+_vm._s(_vm._f("dateFormat")(new Date(this.value),"HH:mm"))+" ")]):_vm._e()]):_c('div',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }